import React from 'react';
import { Box, Button } from '@mui/material'

import FormPaymentJob from '../../../../components/FormPaymentJob/FormPaymentJob';
import config from '../../../../constants/config';
import { JobT } from '../../../../types/Job';
import { TransactionT } from '../../../../types/TransactionT';
import { copyObject, randomId } from '../../../../utils';
import { getCurrentUserId } from '../../../../utils/currentUser';
import {  AxiosInstance } from '../../../../utils/RequestMethods';
import { parseFloatTotal } from '../../../../utils/utilsT';

import { extractVariable } from '../JobUtils';
import PayByCard from '../../../../components/FormPaymentJob/PayByCard/PayByCard';

export type IFormChangingMoveDateProps = {
    job: JobT
    date: string
    startTime: string
    endTime: string
    show(): void
    hide(): void
    onCompleteProcessing(): void
}

const FormChangingMoveDate: React.FC<IFormChangingMoveDateProps> = (props) => {
    const [tempJob, setTempJob] = React.useState<JobT>(null)
    const changeDatetimeFee = React.useMemo(() => extractVariable(props.job.companyInfo.variables, "changeDatetimeFee"), [props.job])
    const currentUserId = getCurrentUserId()
    const [showFormPayment, setShowFormPayment] = React.useState(false);
    const productItemId = randomId(12)

    const productRate = changeDatetimeFee ? changeDatetimeFee.value : 1

    React.useEffect(() => {


    }, []);

    /**
     *
     */
    const saveChange = async (date: string, startTime: string, endTime: string, transcation: TransactionT) => {
        const params = {
            date: date,
            startTime: startTime,
            endTime: endTime,
            transactionId: transcation.id,
        }

        try {
            let res = await AxiosInstance.post(`${config.url.jobs}/${props.job.id}/change-move-date`, params)
        } catch (error) {
            console.log("error", `${error}`)
        }
    }



    return (
        <div>
            <h5>Changing a move date or time is ${parseFloatTotal(productRate)}.</h5>
            {(showFormPayment) && <div>

                <Box width="100%">

                    <PayByCard
                        productId={props.job.id}
                        userId={currentUserId}
                        productType={"jobs"}

                        paymentItems={[
                            {
                                productItem: "changeDatetimeFee",
                                amount: productRate,
                                productItemId: productItemId,
                                productRate: productRate,
                                productUnits: 1
                            }
                        ]}
                        onCompleteProcessing={(transaction) => {
                            // if (props.refresh) {
                            //     props.refresh()
                            // }

                            setShowFormPayment(false)

                            saveChange(props.date, props.startTime, props.endTime, transaction)
                            props.onCompleteProcessing()
                        }}

                    />
                </Box>
                {/* <FormPaymentJob
                    jobId={props.job.id}
                    amount={productRate}
                    userId={currentUserId}
                    productItemId={productItemId}
                    productItem={"changeDatetimeFee"}
                    productRate={productRate}
                    productUnits={1}
                    onCompleteProcessing={(transaction) => {
                        // if (props.refresh) {
                        //     props.refresh()
                        // }

                        setShowFormPayment(false)

                        saveChange(props.date, props.startTime, props.endTime, transaction)
                        props.onCompleteProcessing()
                    }}
                /> */}
            </div>}
            <Box marginLeft={1} marginRight={1}>

                {!showFormPayment ? <Button variant="outlined" color="primary"
                    style={{ paddingTop: 2, marginBottom: 8 }}
                    onClick={(e) => {
                        e.preventDefault()
                        setShowFormPayment(true)
                        setTempJob(props.job)
                        props.show()
                    }}>
                    Change move date?
                </Button>
                    : <Button variant="outlined"
                        style={{ paddingTop: 2, marginBottom: 8 }}
                        onClick={(e) => {
                            e.preventDefault()
                            setShowFormPayment(false)
                            props.hide()
                        }}>
                        Cancel
                    </Button>}



            </Box>

        </div>
    );
}

export { FormChangingMoveDate }
